export default {
  overruleResult: 'Overrule result',
  overruleReason: 'Overrule reason',
  overruleResultLabel: 'Overrule result',
  valueSensorMeaningsPlaceholder: 'Select main signal',
  durationMeaningsPlaceholder: 'Select duration signal',
};
